// @flow

import sampleFocus from './sampleFocus.formatter';
import groupFormatter from '../../../formatters/group.formatter';
import type { FormatterArgs } from '../../../types';
import rstAlloFormatter from "./rstAllo.formatter";

const formatters = (args?: FormatterArgs): Array<any> =>
  [rstAlloFormatter, sampleFocus, groupFormatter].map(formatter => formatter(args));

export default formatters;
